import React from 'react';
import { DateTime, SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ImportSetSectionType } from '../metroline/types';
import { ImportSetFormIds } from '../constants';
import { ImportSetActionType, ImportSetSection } from '../types';
import { SelectSingle } from 'app/area/shared/translated-components';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { endpoints } from 'app/area/import-sets-administration/form/endpoints';
import { ImportDatabaseId } from 'app/area/import-sets-administration/form/components/import-database-id';

export const ImportSetDetails: React.FC<ImportSetSection> = ({
  importSetItem, actionType, updateItem, loadOptions, options, locale, validation, translation, section, getRef, shouldRenderSection
}) => {

  const onDisabledChange = (disabled: Date) => {
    updateItem({ disabled });
  };

  const onImportDatabaseIdChange = (importDatabaseId: number) => {
    updateItem({ importDatabaseId });
  };

  const onCriteriaDomainChange = (criteriaDomain: ComplexValue<number>) => {
    updateItem({ criteriaDomain });
  };

  const onCriteriaDomainLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(ImportSetFormIds.criteriaDomain, endpoints.criteriaDomainOptions, loadOptionsParams);
  };

  const onConstraintSetChange = (importConstraintSet: ComplexValue<number>) => {
    updateItem({ importConstraintSet });
  };

  const onConstraintSetLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(ImportSetFormIds.importConstraintSet, endpoints.importConstraintSetOptions, loadOptionsParams);
  };

  const isReadOnly = importSetItem?.id === 0;

  return <MetroLineSection<ImportSetSectionType>
    section={section}
    sectionType={ImportSetSectionType.Details}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ImportSetSectionType.Details)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ImportSetSectionType.Details}
        validation={undefined}
        info={{ text: translation.details }}
        label={{ visible: true, text: translation.details }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <ImportDatabaseId
              actionType={actionType}
              value={importSetItem?.importDatabaseId}
              required={actionType === ImportSetActionType.edit && !isReadOnly}
              readOnly={isReadOnly}
              onChange={onImportDatabaseIdChange}
              validation={validation?.[ImportSetFormIds.importDatabaseId]}
              locale={locale}
              translation={translation} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <DateTime
              componentId={ImportSetFormIds.disabled}
              className="dateTime"
              value={importSetItem?.disabled}
              label={translation ? { text: translation.disabled } : undefined}
              readOnly={isReadOnly}
              useTime={false}
              parseDate={parseAsDateUTC}
              createDate={createUTCDate}
              cloneDate={dateToUTC}
              {...createFormatters(locale)}
              locale={locale}
              onChange={onDisabledChange}
              captionWrapper={'form'}
              validation={validation?.[ImportSetFormIds.disabled]} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <SelectSingle
              componentId={ImportSetFormIds.criteriaDomain}
              className={undefined}
              valueItem={importSetItem?.criteriaDomain}
              label={{ text: translation.criteria_domain, visible: true }}
              readOnly={isReadOnly}
              options={options?.[ImportSetFormIds.criteriaDomain]?.codes as ComplexValue<number>[] || []}
              placeholder={translation?.search}
              validation={validation?.[ImportSetFormIds.criteriaDomain]}
              fetching={options?.[ImportSetFormIds.criteriaDomain]?.fetching}
              onLoadOptions={onCriteriaDomainLoadOptions}
              onChange={onCriteriaDomainChange} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <SelectSingle
              componentId={ImportSetFormIds.importConstraintSet}
              className={undefined}
              valueItem={importSetItem?.importConstraintSet}
              label={{ text: translation.constraint_set, visible: true }}
              readOnly={isReadOnly}
              options={options?.[ImportSetFormIds.importConstraintSet]?.codes as ComplexValue<number>[] || []}
              placeholder={translation?.search}
              validation={validation?.[ImportSetFormIds.importConstraintSet]}
              fetching={options?.[ImportSetFormIds.importConstraintSet]?.fetching}
              onLoadOptions={onConstraintSetLoadOptions}
              onChange={onConstraintSetChange} />
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
